<div class="items">
  <a routerLink="/deiatelnost/normirovanie-i-standartizatsiia">Техническое нормирование и стандартизация</a>
  <a routerLink="/uslugi/tekhnicheskie-svidetelstva">Технические свидетельства</a>
  <a routerLink="/deiatelnost/tk-465-stroitelstvo">Технический комитет 465 «Строительство»</a>
  <a routerLink="/deiatelnost/stu">Специальные технические условия</a>
  <a routerLink="/deiatelnost/ksi"></a>
</div>
